import gql from 'graphql-tag';
import { ProfileDataFragment } from './profile-data.fragment';
import { UserConnectionFragment } from './user-connection.fragment';
import { lightStatsFragment } from './light-stats.fragment';
import { unreadNotificationsFragments } from './unread-notifications.fragments';

export const miniUserFragment = gql`
  fragment miniUserFragment on User {
    ID
    email
    handle
    lastEdited

    ifollow
    followsYou

    DateJoined

    profileData {
      ...ProfileDataFragment
    }

    connections {
      ...UserConnectionFragment
    }

    lightStats {
      ...lightStatsFragment
    }

    unreadNotifications {
      ...unreadNotificationsFragments
    }
  }
  ${ProfileDataFragment}
  ${UserConnectionFragment}
  ${lightStatsFragment}
  ${unreadNotificationsFragments}
`;
